import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

const InfoModal = props => {
  const { isOpen, onClose, title, text } = props;

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="form-dialog-title">
      <Toolbar className="text-center">
        <Typography variant="title" color="inherit" className="flex">
          {title}
        </Typography>
        <IconButton color="inherit" onClick={onClose}>
          <CloseIcon className="blue" />
        </IconButton>
      </Toolbar>

      <DialogContent className="dialog text-center">
        <span>{text}</span>
      </DialogContent>
    </Dialog>
  );
};

export default InfoModal;
